import React from "react";

export function VideoIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_11820_10450)">
        <path
          d="M21.4289 0.857422H2.57171C1.62493 0.857422 0.857422 1.62493 0.857422 2.57171V21.4289C0.857422 22.3756 1.62493 23.1431 2.57171 23.1431H21.4289C22.3756 23.1431 23.1431 22.3756 23.1431 21.4289V2.57171C23.1431 1.62493 22.3756 0.857422 21.4289 0.857422Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.41211 18.1028V11.5371C9.4169 11.4362 9.44639 11.338 9.49798 11.2512C9.54957 11.1643 9.62169 11.0915 9.708 11.039C9.79432 10.9865 9.8922 10.9561 9.99304 10.9502C10.0939 10.9444 10.1946 10.9635 10.2864 11.0057L15.9778 14.2799C16.07 14.3367 16.1461 14.4162 16.1989 14.5107C16.2517 14.6052 16.2794 14.7117 16.2794 14.8199C16.2794 14.9282 16.2517 15.0347 16.1989 15.1292C16.1461 15.2237 16.07 15.3032 15.9778 15.3599L10.2864 18.6514C10.193 18.6898 10.0919 18.7053 9.99129 18.6967C9.89071 18.6881 9.79364 18.6556 9.70813 18.602C9.62263 18.5483 9.55117 18.4751 9.49968 18.3882C9.44819 18.3014 9.41817 18.2036 9.41211 18.1028V18.1028Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.857422 6.85742H23.1431"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.85742 6.85742L9.42885 0.857422"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5713 6.85742L17.1427 0.857422"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11820_10450">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
